import GalleryPreview from './GalleryPreview';

export default class GridGalleryPreview extends GalleryPreview {

	constructor(node, index, type) {
		super(node, index, type);
		var options = this.getOptions()
		options.caption = 'caption'
		this.setOptions(options);

		this.initSlickLightbox(this.getOptions());
	}

}